<template>
  <div class="wrap">
    <!--API接口参数-->
    <div class="box-padding">
      <div class="box-title">
        <span class="box-api">API</span>
        <span class="text-red">*</span>
        <span class="box-tip">为必填参数，未正确输入无法测试</span>
      </div>
      <div class="debug-box">
        <Form>
          <FormItem>
            <Row>
              <Col span="4">
                <label style="float: right;line-height: 32px;"><span class="text-red">*</span>appkey：</label>
              </Col>
              <Col span="10" style="padding: 0 5px;">
                <Input placeholder="请输入" />
              </Col>
              <Col span="10">
                <label style="line-height: 32px;">填写分配给应用的appkey</label>
              </Col>
            </Row>
          </FormItem>
          <FormItem>
            <Row>
              <Col span="4">
                <label style="float: right;line-height: 32px;"><span class="text-red">*</span>appsecret：</label>
              </Col>
              <Col span="10" style="padding: 0 5px;">
                <Input placeholder="请输入" />
              </Col>
              <Col span="10">
                <label style="line-height: 32px;">填写分配给应用的appsecret</label>
              </Col>
            </Row>
          </FormItem>
          <FormItem>
            <Row>
              <Col span="4">
                <label style="float: right;line-height: 32px;"><span class="text-red">*</span>version：</label>
              </Col>
              <Col span="10" style="padding: 0 5px;">
                <Input placeholder="请输入" />
              </Col>
              <Col span="10">
                <label style="line-height: 32px;">版本号</label>
              </Col>
            </Row>
          </FormItem>
          <FormItem>
            <Row>
              <Col span="4">
                <label style="float: right;line-height: 32px;"><span class="text-red">*</span>接口：</label>
              </Col>
              <Col span="10" style="padding: 0 5px;">
                <Select style="width:150px" placeholder="请选择">
                  <Option v-for="item in apiList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
              </Col>
            </Row>
          </FormItem>
          <FormItem>
            <Row>
              <Col span="4">
                <label style="float: right;line-height: 32px;"><span class="text-red">*</span>必填参数名称：</label>
              </Col>
              <Col span="10" style="padding: 0 5px;">
                <Input placeholder="请输入" />
              </Col>
            </Row>
          </FormItem>
          <FormItem>
            <Row>
              <Col span="4">
                <label style="float: right;line-height: 32px;">选填参数名称：</label>
              </Col>
              <Col span="10" style="padding: 0 5px;">
                <Input placeholder="请输入" />
              </Col>
            </Row>
          </FormItem>
          <FormItem style="padding-left: 16.7%;">
            <Button type="warning">提交测试</Button>
          </FormItem>
        </Form>
      </div>
    </div>
    <div class="box-padding">
      <div class="box-title">
        <span class="box-api">输出参数</span>
      </div>
      <div class="response-box">
        <json-viewer :value="responseData"></json-viewer>
      </div>
    </div>
  </div>
</template>
<script>
import { Form, Select, Option, Input, Button, Row, Col, FormItem } from 'view-design'

export default {
  name: 'DocumentDebug',
  components: {
    Form,
    Select,
    Option,
    Input,
    Button,
    Row,
    Col,
    FormItem
  },
  data () {
    return {
      apiList: [
        {
          value: '1',
          label: '影院列表'
        },
      ],
      responseData: {
      },
    }
  }
}
</script>
<style scoped>
  .box-padding {
    padding-top: 20px;
  }
  .box-padding .box-title{
    line-height: 30px;
  }
  .box-padding .box-title .box-api{
    font-size: 20px;
    font-weight: bolder;
  }
  .text-red{
    color: #FF0052;
  }
  .box-padding .box-title .box-tip{
    color: #666666;
    font-weight: normal;
    font-size: 13px;
  }
  .box-padding .debug-box{
    margin-top: 20px;
    padding: 20px 0;
    border: 1px solid #E4E4E4;
  }
  .box-padding .response-box{
    margin-top: 20px;
    border: 1px solid #E4E4E4;
  }
</style>



// WEBPACK FOOTER //
// src/views/pc/document/api/debug/Index.vue